import React, { useEffect, useState } from 'react';
import Routes from 'routes';
import { customFetch } from 'utils/fetch';

type Option = { id: number; name: string; active?: boolean };

interface ProfileSelectProps {
  sensorialAnalysisId?: number;
  selectedProfileId?: number;
  profiles?: Array<{ id: number; name: string; active?: boolean }>;
  name?: string;
}

const ProfileSelect: React.FC<ProfileSelectProps> = ({
  sensorialAnalysisId,
  selectedProfileId,
  profiles: passedProfiles,
  name,
}) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [value, setValue] = useState<string>(
    selectedProfileId ? String(selectedProfileId) : ''
  );

  useEffect(() => {
    if (passedProfiles && passedProfiles.length) {
      setOptions(passedProfiles as Option[]);
      return;
    }

    const url = (Routes as any).api_v1_profiles_path
      ? (Routes as any).api_v1_profiles_path()
      : '/api/v1/profiles';
    customFetch(url, undefined, 'GET').then((data: Option[]) => setOptions(data || []));
  }, [passedProfiles]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (sensorialAnalysisId) {
      const url = (Routes as any).api_v1_sensorial_analysis_path
        ? (Routes as any).api_v1_sensorial_analysis_path(sensorialAnalysisId)
        : `/api/v1/sensorial_analyses/${sensorialAnalysisId}`;

      const payload = {
        sensorial_analysis: {
          profile_id: newValue || null,
        },
      };

      customFetch(url, payload, 'PATCH');
    }
  };

  // Show nothing if no sensorialAnalysisId
  if (!sensorialAnalysisId) return null;

  return (
    <div className='input-group input-group--inline sensorial-analyses__profile-select'>
      <select
        name={name}
        className='input--condensed'
        id={`profile_${sensorialAnalysisId}`}
        value={value}
        onChange={handleChange}
      >
        <option value=''>
          {I18n.translate('sensorial_analysis.select_profile', {
            defaultValue: 'Seleccione un perfil',
          })}
        </option>
        {options
          .filter((o) => {
            const isActive = o.active !== false;
            const isCurrentlyAssigned =
              selectedProfileId !== undefined &&
              selectedProfileId !== null &&
              String(o.id) === String(selectedProfileId);
            return isActive || isCurrentlyAssigned;
          })
          .map((o) => {
            const isActive = o.active !== false;
            const label = isActive
              ? o.name
              : `${o.name} (${I18n.translate('common.inactive')})`;
            return (
              <option key={o.id} value={o.id}>
                {label}
              </option>
            );
          })}
      </select>
    </div>
  );
};

export default ProfileSelect;
